export const getShortDate = (date?: string) => {
  if (!date) {
    return null;
  }

  return new Date(date).toLocaleDateString('pt-BR', {
    timeZone: 'UTC',
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
};
